import { faUpload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import { modalClose, modalOpen } from '@app/store/modal/actions';

import LogoImageDropZone from './LogoImageDropZone';
import LogoImageInfoView from './LogoImageInfoView';

const propTypes = {
  onModalClose: PropTypes.func,
  onModalOpen: PropTypes.func,
  onSubmit: PropTypes.func,
};

const defaultProps = {
  onModalClose() {},
  onModalOpen() {},
  onSubmit() {},
};

export class CustomEmailSettingLogoImageUploadModalComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: '',
      isUpload: false,
      logo: {},
    };
    this.handleClickUpload = this.handleClickUpload.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleLogoChange = this.handleLogoChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  handleClickUpload() {
    const { onSubmit } = this.props;
    const { logo } = this.state;

    onSubmit(logo);
  }

  handleCloseModal() {
    const { onModalClose } = this.props;
    onModalClose();
  }

  handleLogoChange({ logo, fileName }) {
    this.setState({
      fileName,
      isUpload: true,
      logo,
    });
  }

  handleReset() {
    this.setState({
      fileName: '',
      isUpload: false,
      logo: {},
    });
  }

  render() {
    const { onModalOpen } = this.props;
    const { fileName, logo, isUpload } = this.state;

    return (
      <div className="Container Container--sm">
        <div className="Card Card--pop WindowModal WindowModal--fixed-height">
          <div className="WindowModal__header">
            <h4 className="WindowModal__header-title">
              <FontAwesomeIcon icon={faUpload} /> 로고 이미지 업로드
            </h4>
            <button
              className="WindowModal__header-close-btn"
              name="close"
              type="button"
              onClick={this.handleCloseModal}
            />
          </div>
          <div className="CustomEmailSettingLogoImageUpload">
            {isUpload ? (
              <LogoImageInfoView
                base64={logo.base64}
                fileName={fileName}
                onReset={this.handleReset}
              />
            ) : (
              <LogoImageDropZone onChange={this.handleLogoChange} onModalOpen={onModalOpen} />
            )}
          </div>
          <div className="WindowModal__footer align-center">
            <button
              className="Btn Btn--primary Btn--lg"
              disabled={!isUpload && 'disable'}
              name="upload"
              type="button"
              onClick={this.handleClickUpload}
            >
              업로드
            </button>
          </div>
        </div>
      </div>
    );
  }
}

CustomEmailSettingLogoImageUploadModalComponent.propTypes = propTypes;
CustomEmailSettingLogoImageUploadModalComponent.defaultProps = defaultProps;

const mapDispatchToProps = {
  onModalClose: modalClose,
  onModalOpen: modalOpen,
};

export default connect(null, mapDispatchToProps)(CustomEmailSettingLogoImageUploadModalComponent);
